module.exports = __webpack_public_path__ + "static/Unilever-DSEP-ClassroomActivity-Virtual-2.2-WeightBasedBullying[Port]-a63fe4778fb8e0189fa8302d7a37d693.pdf";